import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { MessageCircle, X, Send } from "lucide-react";

export default function Chatbot() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        data-testid="chatbot-toggle"
        aria-label="Assistent öffnen"
        onClick={() => setOpen(true)}
        className="fixed right-6 bottom-28 z-40 w-14 h-14 rounded-full grid place-items-center bg-[#C0C0C0] text-[#0A0A0A] shadow-[0_8px_30px_rgba(192,192,192,0.35)] transition-transform duration-300 hover:scale-110"
      >
        <MessageCircle size={26} strokeWidth={1.6} />
      </button>

      <AnimatePresence>
        {open && (
          <>
            <motion.div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 0.25 }}
              onClick={() => setOpen(false)}
              className="fixed inset-0 z-[60] bg-black/30 backdrop-blur-sm"
              aria-hidden="true"
            />

            <motion.div
              role="dialog"
              aria-modal="true"
              aria-label="RF-KFZ Assistent"
              data-testid="chatbot-modal"
              initial={{ opacity: 0, y: 30, scale: 0.96 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 30, scale: 0.96 }}
              transition={{ duration: 0.3, ease: [0.65, 0, 0.35, 1] }}
              className="fixed z-[70] right-4 left-4 bottom-28 mx-auto md:right-6 md:left-auto md:bottom-28 md:mx-0 md:w-[380px] md:h-[520px] max-h-[80vh] flex flex-col overflow-hidden border border-white/10 bg-[#0A0A0A] shadow-[0_20px_60px_rgba(0,0,0,0.55)]"
              style={{ width: "min(90vw, 380px)" }}
            >
              <header className="flex items-center justify-between px-5 py-4 border-b border-white/8 bg-[#0A0A0A]">
                <div className="flex items-center gap-3">
                  <span className="relative w-8 h-8 grid place-items-center border border-white/15 rotate-45">
                    <span className="block w-1.5 h-1.5 -rotate-45 bg-[var(--rf-red)] rounded-full" />
                  </span>
                  <div>
                    <div className="font-display text-sm tracking-[0.05em] text-white">
                      RF KFZ Assistent
                    </div>
                    <div className="font-mono-tag text-[0.62rem] text-white/40 mt-0.5 flex items-center gap-1.5">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#25D366]" />
                      Online
                    </div>
                  </div>
                </div>
                <button
                  type="button"
                  data-testid="chatbot-close"
                  onClick={() => setOpen(false)}
                  aria-label="Schließen"
                  className="w-9 h-9 grid place-items-center border border-white/10 text-white/70 hover:border-[var(--rf-red)] hover:text-[var(--rf-red)] transition-colors"
                >
                  <X size={16} />
                </button>
              </header>

              <div className="flex-1 overflow-y-auto px-5 py-6 space-y-5 bg-gradient-to-b from-[#0A0A0A] to-[#141414]">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 shrink-0 rounded-full bg-[var(--rf-red)]/15 border border-[var(--rf-red)]/40 grid place-items-center">
                    <span className="block w-1.5 h-1.5 bg-[var(--rf-red)] rounded-full" />
                  </div>
                  <div className="bg-white/5 border border-white/10 px-4 py-3 text-sm text-white/85 leading-relaxed max-w-[85%]">
                    Hallo! Ich bin der digitale Assistent der RF KFZ Meisterbetrieb GmbH.
                    Wie kann ich Ihnen helfen? Stellen Sie Ihre Fragen zu §57a-Begutachtung,
                    Diagnose, Service oder Reifen.
                  </div>
                </div>

                <div className="text-center">
                  <div className="inline-block font-mono-tag text-[0.62rem] text-white/40 border border-white/10 px-3 py-1.5">
                    Demnächst verfügbar — bitte kontaktieren Sie uns über WhatsApp
                  </div>
                </div>
              </div>

              <footer className="px-4 py-3 border-t border-white/8 bg-[#0A0A0A] flex items-center gap-2">
                <input
                  type="text"
                  disabled
                  placeholder="Ihre Nachricht..."
                  data-testid="chatbot-input"
                  className="flex-1 bg-white/5 border border-white/10 px-4 py-2.5 text-sm text-white/60 placeholder-white/30 outline-none disabled:cursor-not-allowed"
                />
                <button
                  type="button"
                  disabled
                  data-testid="chatbot-send"
                  aria-label="Senden"
                  className="w-10 h-10 grid place-items-center border border-white/10 bg-white/5 text-white/40 disabled:cursor-not-allowed"
                >
                  <Send size={15} />
                </button>
              </footer>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </>
  );
}
